import { atom } from "jotai";
import { iframeFocusModeAtom, previewNodeIdAtom } from "../canvas";
import { nodeAtomFamily } from "../nodes";
import { DefaultNodeData, NodeType } from "../types";
import { determineAssetType, getAssetId } from "../utils";

type RefreshAssetPostMessageParamsType = {
  type: "canvas:copilot-update";
  stepId?: string;
  subStepKey?: string;
  interfaceId?: string;
  pageId?: string;
  tableId?: string;
};

/**
 * Atom setter for triggering asset refresh via postMessage.
 * Gets asset information directly from the preview node data.
 */
export const refreshAssetSetter = atom(null, (get) => {
  const iframe = get(iframeFocusModeAtom);
  const previewNodeId = get(previewNodeIdAtom);
  const previewNode = get(nodeAtomFamily(previewNodeId || ""));

  if (!iframe || !iframe.contentWindow || !previewNode) {
    return;
  }

  const { data, type } = previewNode;
  const assetType = determineAssetType(
    (data as DefaultNodeData).services,
    type as NodeType,
  );
  const assetId = getAssetId(data, assetType);
  const interfaceProjectId = (data as DefaultNodeData).projectId;

  if (!assetId || !assetType) {
    return;
  }

  const payload: RefreshAssetPostMessageParamsType = {
    type: "canvas:copilot-update",
  };

  if (assetType === "zap") {
    payload.stepId = assetId;
    payload.subStepKey = "setup";
  }

  if (assetType === "interface") {
    payload.interfaceId = interfaceProjectId;
    payload.pageId = assetId;
  }

  if (assetType === "table") {
    payload.tableId = assetId;
  }

  // Send the message to the iframe's parent window
  iframe.contentWindow.postMessage(payload, "*");
});

refreshAssetSetter.debugLabel = "refreshAssetSetter";
